import { render, staticRenderFns } from "./RegistrationInnerForm.vue?vue&type=template&id=30a99fc4"
import script from "./RegistrationInnerForm.vue?vue&type=script&lang=js"
export * from "./RegistrationInnerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports